import { Commun } from '../utils/axios';
/**
 * 乐学首页公告接口
 */
export const getLexueNotice = () => {
  return Commun.get('/dp/client/api/star/merchandise/announcement');
};
